module.exports = __webpack_public_path__ + "static/office-26377cd394d0101a61a0c22bb4806fbf.png";